module.exports = __webpack_public_path__ + "static/media/ogon.5e88386c.svg";